export default __webpack_public_path__ + "static/media/caracteristicas.f0b882be.png";